import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { getDefectsRegistered } from "services/analytics";
import { Apis } from "services/api";
import { defectStatusTypes } from "helpers/constants";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsRegisteredReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();
  const chartConfig = {
    id: 'defects-registered',
    title: t("title.entityRegistered", { entity: customCaptions?.defectPlural }),
    fetchData: async (params) => {
      return await getDefectsRegistered(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{
        label: t("label.count")
      }]
    },
    series: [
        {
          label: t("label.registered"),
          key: 'count',
          colors: getAllColors(),
          showLegend: false
        }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    viewData: '/app/defects', //This could be a function that returns the path based on the data
    itemNavigation: true,
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true,
      riskRatings: true,
      defectType: true,
      defectStatusType: true,
      workOrder: true,
    },
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{
          label: t("label.count")
        }]
      },
      series: [
        {
          label: t("label.count"),
          key: 'count',
          showLegend: false,
          colors: getAllColors()
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
    }
  };

  return (
    <ReportPage 
      title={t("title.entityRegistered", { entity: customCaptions?.defectPlural })}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsRegisteredReport; 
